import { Image } from '@cian/ui-kit';
import { IconPlaceholderImages24 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import styles from './CardImage.css';
import { IHeaderCard } from '../../../../../types/chatHeader';

export const CardImage: React.FC<IHeaderCard['image']> = image => {
  if (image.type === 'remote' && image.url) {
    return <Image width={40} height={40} objectFit="cover" src={image.url} data-testid="image" />;
  }

  if (image.type === 'placeholder') {
    return (
      <div className={styles['empty']} data-testid="empty_image">
        <IconPlaceholderImages24 color="current_color" />
      </div>
    );
  }

  return null;
};
